export default __webpack_public_path__ + "static/media/aside__user-bg.ac8840ad.png";